import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupLockRequestResultDto, IsLockedLockInfoDto, LockRequestResultDto, LockTypeRequestDto } from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class LockRepository {
  constructor(private httpClientService: PrmHttpClientService) { }

  putGroupLock(objectId: string, lockType: string, lastRead?: string, instanceId?: string): Observable<GroupLockRequestResultDto> {
    const endpointUrl = `locks/group/${objectId}/${lockType}/${lastRead}` + (instanceId ? `?instanceId=${instanceId}` : '');
    return this.httpClientService.sendPutRequest(endpointUrl, null);
  }

  putGroupLocks(objectIds: string[], lockType: string, lastRead?: string, instanceId?: string): Observable<GroupLockRequestResultDto[]> {
    const endpointUrl = `locks/group/${lockType}/${lastRead}` + (instanceId ? `?instanceId=${instanceId}` : '');
    return this.httpClientService.sendPutRequest(endpointUrl, objectIds);
  }

  putGroupLocksByLockTypes(
    lockRequest: LockTypeRequestDto[],
    lastRead?: string,
    instanceId?: string,
  ): Observable<GroupLockRequestResultDto[]> {
    const endpointUrl = `locks/group/lock-types/${lastRead}` + (instanceId ? `?instanceId=${instanceId}` : '');
    return this.httpClientService.sendPutRequest(endpointUrl, lockRequest);
  }

  putGroupUnlock(instanceId: string): Observable<void> {
    const endpointUrl = `locks/groupunlock/${instanceId}`;
    return this.httpClientService.sendPutRequest(endpointUrl, null);
  }

  getLock(objectId: string, lockType: string, instanceId?: string): Observable<IsLockedLockInfoDto> {
    const endpointUrl = `locks/${objectId}/${lockType}` + (instanceId ? `?instanceId=${instanceId}` : '');
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  putLock(objectId: string, lockType: string, instanceId?: string): Observable<LockRequestResultDto> {
    const endpointUrl = `locks/${objectId}/${lockType}` + (instanceId ? `?instanceId=${instanceId}` : '');
    return this.httpClientService.sendPutRequest(endpointUrl, null);
  }

  deleteLock(objectId: string, lockType: string, instanceId?: string): Observable<void> {
    const endpointUrl = `locks/${objectId}/${lockType}` + (instanceId ? `?instanceId=${instanceId}` : '');
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }

  deleteLockGroup(instanceId: string): Observable<void> {
    const endpointUrl = `locks/groupdelete/${instanceId}`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }

}
